import * as giftShelfManagement from '../services/giftShelfManagement';

export default {
  namespace: 'giftShelfManagement',

  state: {
    userInfo: null,
    memberPageList: null,
    addMember: null,
    levels: [],
  },

  effects: {
    //货架列表
    *getQueryStoreShelfList({ payload: { values } }, { call, put }) {
      const response = yield call(
        giftShelfManagement.getQueryStoreShelfList,
        values,
      );
      yield put({
        type: 'save',
        payload: {
          queryShelfList: response?.data,
        },
      });
    },

    *deleteShelf({ payload: { values }, callback }, { call }) {
      const res = yield call(giftShelfManagement.deleteShelf, values);
      callback(res);
    },
    *canDeleteGoodsShelf({ payload: { values }, callback }, { call }) {
      const res = yield call(giftShelfManagement.canDeleteGoodsShelf, values);
      callback(res);
    },
    //导出货架数据明细报表
    *exportShelfItemData({ payload: { values }, callback }, { call }) {
      const res = yield call(giftShelfManagement.exportShelfItemData, values);
      callback(res);
    },
    //导出货架数据汇总报表
    *exportShelfSummaryData({ payload: { values }, callback }, { call }) {
      const res = yield call(
        giftShelfManagement.exportShelfSummaryData,
        values,
      );
      callback(res);
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
